<script setup lang="ts">
import { reactive } from "vue";
import { useRouter } from "vue-router";
import * as empresaService from "@/services/empresaService";
import imgLogin from "@/assets/images/logoLogin.png";

const router = useRouter();

const controle = reactive({
  senhaAtual: "",
  senhaNova: "",
  senhaNovaConfirmacao: "",
  status: "",
  erro: "",
  sucesso: ""
});

function alterar() {
  controle.erro = "";
  controle.sucesso = "";

  if (!controle.senhaAtual || !controle.senhaNova || !controle.senhaNovaConfirmacao) {
    controle.erro = "Preencha todos os campos.";
    return;
  }

  if (controle.senhaNova !== controle.senhaNovaConfirmacao) {
    controle.erro = "Nova senha e confirmação não conferem.";
    return;
  }

  if (controle.senhaNova.length < 6) {
    controle.erro = "A nova senha deve ter pelo menos 6 caracteres.";
    return;
  }

  controle.status = "Alterando senha...";

  empresaService.alterarSenha(controle.senhaAtual, controle.senhaNova, controle.senhaNovaConfirmacao)
    .then((r) => {
      controle.status = "";
      controle.sucesso = r.mensagem || "Senha alterada com sucesso!";
      controle.senhaAtual = "";
      controle.senhaNova = "";
      controle.senhaNovaConfirmacao = "";
    })
    .catch((error) => {
      controle.status = "";
      controle.erro = error.message || "Erro ao alterar senha.";
    });
}
</script>

<template>
  <div class="row justify-content-center mt-4">
    <div class="col-md-5">

      <div class="card shadow-sm">
        <div class="card-body">

          <div class="text-center mb-3">
            <img :src="imgLogin" alt="Logo" class="img-fluid" style="max-height: 60px;">
            <h5 class="mt-2 mb-0">Alterar Senha</h5>
          </div>

          <div class="mb-3">
            <label class="form-label">Senha atual</label>
            <input type="password" class="form-control form-control-sm" v-model="controle.senhaAtual" placeholder="Digite sua senha atual">
          </div>

          <div class="mb-3">
            <label class="form-label">Nova senha</label>
            <input type="password" class="form-control form-control-sm" v-model="controle.senhaNova" placeholder="Mínimo 6 caracteres">
          </div>

          <div class="mb-3">
            <label class="form-label">Confirmar nova senha</label>
            <input type="password" class="form-control form-control-sm" v-model="controle.senhaNovaConfirmacao" placeholder="Repita a nova senha">
          </div>

          <div class="d-flex gap-2">
            <button type="button" class="btn btn-primary btn-sm" @click="alterar()">Salvar</button>
            <button type="button" class="btn btn-secondary btn-sm" @click="router.push({ name: 'PainelEmpresa' })">Voltar</button>
          </div>

          <div class="mt-3 text-primary" v-if="controle.status">{{ controle.status }}</div>
          <div class="mt-3 text-success" v-if="controle.sucesso">{{ controle.sucesso }}</div>
          <div class="mt-3 text-danger" v-if="controle.erro">{{ controle.erro }}</div>

        </div>
      </div>

    </div>
  </div>
</template>
